import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { LoadingOutlined } from '@ant-design/icons';

import './styles.less';

export const ActionButton = ( props ) => {
    // Construct the classes to use for the root component.
    const classes = classnames(
        'action-button',
        { 'disabled': Boolean( props.disabled ) || Boolean( props.loading ) },
        { 'loading': Boolean( props.loading ) },
        { 'animate': Boolean( props.animate ) },
        { 'important': Boolean( props.important ) },

        // Predefined color styles
        { 'blue': Boolean( props.blue ) },
        { 'green': Boolean( props.green ) },

        { [ props.className ]: Boolean( props.className ) },
    );
    
    return (
        <div
            role="button"
            className={ classes }
            onClick={ ( !props.loading && !props.disabled ) ? props.onClick : undefined }
        >
            <div className="action-button-content">
                <div className="action-button-content-loading">
                    <LoadingOutlined className="action-button-spinner" />
                </div>
                <div className="action-button-content-body">
                    { props.children }
                </div>
            </div>
        </div>
    );
};

ActionButton.defaultProps = {
    className: undefined,
    important: false,
    loading: false,
    disabled: false,
    animate: true,
    onClick: undefined,

    blue: true,
    green: false,
};

ActionButton.propTypes = {
    className: PropTypes.string,
    important: PropTypes.bool,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    animate: PropTypes.bool,
    onClick: PropTypes.func,

    blue: PropTypes.bool,
    green: PropTypes.bool,
};
